// Lasiri Capital LPO pre-qualification — questions + gate logic (mirrored server-side in tenant_portal.py).
export const LPO_MIN = 500_000;
export const LPO_MAX = 10_000_000;
export const MAX_TERMS_DAYS = 120;

export const PREQUAL_QUESTIONS = [
  { id: "registered", type: "yesno", q: "Do you have a registered company?",
    help: "A company, partnership or business name registered in Kenya.", failOn: "no" },
  { id: "registered_on", type: "date", q: "When was the business registered?",
    help: "Use the date on your certificate of incorporation or registration." },
  { id: "has_lpo", type: "yesno", q: "Do you have a valid LPO?",
    help: "A signed Local Purchase Order from the client you will supply.", failOn: "no" },
  { id: "lpo_value", type: "kes", q: "What is the value of your LPO?",
    help: "Total order value in Kenyan shillings." },
  { id: "issuer", type: "choice", q: "Who is the issuer of the LPO?",
    options: [{ v: "government", l: "Government" }, { v: "county", l: "County" }, { v: "private", l: "Private entity" }] },
  { id: "supplied_same_client", type: "yesno", q: "Have you previously supplied the same goods or services to this specific client?" },
  { id: "supplied_other_client", type: "yesno", q: "Have you previously supplied the same goods or services to any other client?" },
  { id: "payment_terms_days", type: "days", q: "What are the payment terms on the LPO?",
    help: "Number of days the client takes to pay after delivery." },
  { id: "has_statements", type: "yesno", q: "Do you have a valid bank statement, M-Pesa statement, audited financials, or management accounts?",
    help: "Any one of these is enough.", failOn: "no" },
];

// Returns null when the answer passes, otherwise a short plain-English reason.
export const gateReason = (id, value) => {
  switch (id) {
    case "registered": return value === "no" ? "Lasiri Capital only funds registered businesses." : null;
    case "has_lpo": return value === "no" ? "A valid LPO is required for LPO financing." : null;
    case "lpo_value": {
      const n = Number(value);
      if (!Number.isFinite(n) || n <= 0) return "Enter the LPO value.";
      return n < LPO_MIN || n > LPO_MAX ? `Lasiri Capital funds LPOs between KES ${LPO_MIN.toLocaleString()} and KES ${LPO_MAX.toLocaleString()}.` : null;
    }
    case "issuer": return value === "government" || value === "county" ? "Lasiri Capital currently funds LPOs issued by private entities only." : null;
    case "payment_terms_days": {
      const n = Number(value);
      if (!Number.isFinite(n) || n < 0) return "Enter the payment terms in days.";
      return n > MAX_TERMS_DAYS ? `Payment terms must be ${MAX_TERMS_DAYS} days or less.` : null;
    }
    case "has_statements": return value === "no" ? "Financial records (bank/M-Pesa statement, audited financials or management accounts) are required." : null;
    default: return null;
  }
};

const KEY = (sub) => `clinq_tenant_prequal_${sub}`;
export const savePrequal = (sub, data) => { try { sessionStorage.setItem(KEY(sub), JSON.stringify(data)); } catch (_) { /* noop */ } };
export const loadPrequal = (sub) => { try { return JSON.parse(sessionStorage.getItem(KEY(sub)) || "null"); } catch (_) { return null; } };
